// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2Og0v","text":"SelectPayment_text__2I9wH","title":"SelectPayment_title__2UN6p","btn":"SelectPayment_btn__3I_Xl"};